'use client';

import { COOKIE_EXPIRATION_DAYS } from '@/ab-tests/config';
import type { Test } from '@/ab-tests/types';
import { runTestCallbacks } from '@/ab-tests/utils';
import { useSiteId } from '@/contexts/domain/hooks';
import { useSetCookie } from '@/hooks/use-cookies';
import { Cookie } from '@/types/storage';
import { type ReactNode, createContext, useEffect } from 'react';
import { isJSON } from 'validator';

export const AbTestContext = createContext<Test[] | null>(null);

export const AbTestProvider = ({
  children,
  cookieTests = '',
}: {
  children: ReactNode;
  cookieTests?: string;
}) => {
  const siteId = useSiteId();
  const setCookie = useSetCookie();

  useEffect(() => {
    const initialData = isJSON(cookieTests) ? JSON.parse(cookieTests) : '';
    if (!initialData) return;

    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + COOKIE_EXPIRATION_DAYS);

    setCookie(Cookie.AB_TESTS, cookieTests, {
      expires: expirationDate,
    });
    runTestCallbacks(initialData, siteId);
  }, [siteId, cookieTests]);

  return (
    <AbTestContext.Provider
      value={isJSON(cookieTests) ? JSON.parse(cookieTests) : []}
    >
      {children}
    </AbTestContext.Provider>
  );
};
